import React from 'react';
import config from '../config';
import useFetch from '../utils/hooks/useFetch';

import './Header.scss';

export default function Header() {
  const { loading, data } = useFetch(config.contentApi.headerFooter);
  if (loading) return null;
  const subdomain = window.location.hostname.toLowerCase().split(/\.|-/)[0];
  return (
    <div>
      <div className="site-header container-fluid d-flex flex-row py-1">
        <div className="w-50 mt-2">
          <a className="logo mw-100" href="/mobile-token-generator?SYS=UB">
            <img src={data.spectrumMobileLogo} alt="Spectrum Mobile" />
          </a>
        </div>
        <div className="ml-auto text-light text-right text-sm-left mt-1">
          <h4 className="font-weight-bold col-sm">{data.CustomerServiceNumbers[subdomain]}</h4>
        </div>
      </div>
    </div>
  );
}
